import { version } from '../package.json'

const currentEnv = process.env.NODE_ENV || 'development'
const config = {
  env: {
    production: false,
    staging: false,
    test: false,
    development: false,
  },
  urls: {
    apiUrl:
      currentEnv === 'production'
        ? 'https://research.jcu.edu.au/api/orcid-link/v2'
        : '/api/orcid-link/v2', // If this is not set, the 'message' with auth details does not get posted to callback
    messageOrigin:
      currentEnv === 'production'
        ? 'https://research.jcu.edu.au'
        : 'http://localhost:8080',
  },
  app: {
    name: 'ORCID iD Link',
    version: version,
    contact: 'JCU eResearch Centre',
    documentTitle: 'ORCID iD Link - James Cook University',
  },
}
config.env[currentEnv] = true

export default config
